import { AxiosError } from 'axios';
import { newSessionApi, SessionsApi } from '../api/backend/api';

export interface SessionCreateResponse {
  sessionToken: string;
}

export class SessionRepository {
  constructor(private api: SessionsApi) {}

  public async Create(): Promise<SessionCreateResponse> {
    return this.api
      .createSession()
      .then(res => {
        return {
          sessionToken: res.data.sessionToken,
        };
      })
      .catch((err: AxiosError) => {
        // TODO handle error by status
        return Promise.reject(err);
      })
      .catch((err: Error) => {
        return Promise.reject(err);
      });
  }
}

export default function() {
  return new SessionRepository(newSessionApi());
}
